export const TYPE_CODES = {
  CUC:                 'CUC',
  GPR:                 'GPR',
  SOR:                 'SOR',
  GPR_GA:              'GPR_GA',
  GPR_EX:              'GPR_EX',
  GPR_INT:             'GPR_INT',
  GPR_MKT:             'GPR_MKT',
  GPR_EA:              'GPR_EA',
  GPR_RUNBOOK:         'GPR_RUNBOOK',
  PRICING_PACKAGING:   'PRICING_PACKAGING',
  BREAKING_CHANGE:     'BREAKING_CHANGE',
  CIC:                 'CIC',
  PPP:                 'PPP',
  PRIVACY:             'PRIVACY',
  NEW_PRODUCT_REQUEST: 'NEW_PRODUCT_REQUEST',
};

export const GPR_SUBTYPE_CODES = new Set([
  TYPE_CODES.GPR_GA,
  TYPE_CODES.GPR_EX,
  TYPE_CODES.GPR_INT,
  TYPE_CODES.GPR_MKT,
  TYPE_CODES.GPR_EA,
  TYPE_CODES.GPR_RUNBOOK,
]);

// gpr_subtype answer value → type_code (for new request creation from GPR selector)
export const GPR_SUBTYPE_ANSWER_TO_CODE = {
  'New GA Service':   TYPE_CODES.GPR_GA,
  'Existing Service': TYPE_CODES.GPR_EX,
  'Internal Service': TYPE_CODES.GPR_INT,
  'Marketplace':      TYPE_CODES.GPR_MKT,
  'EA Service':       TYPE_CODES.GPR_EA,
  'Runbook Changes':  TYPE_CODES.GPR_RUNBOOK,
};

export const TYPE_DISPLAY_NAMES = {
  [TYPE_CODES.CUC]:                 'Capability Update Catalog',
  [TYPE_CODES.GPR]:                 'GPR',
  [TYPE_CODES.SOR]:                 'SalesOps Request',
  [TYPE_CODES.GPR_GA]:              'GPR - New GA Service',
  [TYPE_CODES.GPR_EX]:              'GPR - Existing Service',
  [TYPE_CODES.GPR_INT]:             'GPR - New Internal Service',
  [TYPE_CODES.GPR_MKT]:             'GPR - Marketplace',
  [TYPE_CODES.GPR_EA]:              'GPR - New EA Service',
  [TYPE_CODES.GPR_RUNBOOK]:         'GPR - Runbook Changes',
  [TYPE_CODES.PRICING_PACKAGING]:   'Pricing & Packaging',
  [TYPE_CODES.BREAKING_CHANGE]:     'Breaking Change',
  [TYPE_CODES.CIC]:                 'Customer Impact Communication (CiC)',
  [TYPE_CODES.PPP]:                 'Platform Packaging & Pricing',
  [TYPE_CODES.PRIVACY]:             'Privacy',
  [TYPE_CODES.NEW_PRODUCT_REQUEST]: 'New Product Request',
};

// Types excluded from reporting when in Draft status
export const DRAFT_EXCLUDED_FROM_REPORTING = new Set([
  TYPE_CODES.BREAKING_CHANGE,
  TYPE_CODES.CIC,
  TYPE_CODES.PPP,
  TYPE_CODES.PRIVACY,
  TYPE_CODES.PRICING_PACKAGING,
  TYPE_CODES.NEW_PRODUCT_REQUEST,
]);

// Override the "Verified" status label for specific types
export const TYPE_VERIFIED_DISPLAY_OVERRIDE = {
  [TYPE_CODES.NEW_PRODUCT_REQUEST]: 'Completed',
};
